import { ParamsBuilder, RowState } from "../types";
import { helper } from "./helper";

export class NumberBuilder implements ParamsBuilder {
  build(row: RowState): object {
    const value = Number(row.value);
    switch (row.operator) {
      case "gt":
        return {
          [row.fieldName]: helper({ gt: value }, { multiTableSearch: row.multiTableSearch })
        };
      case "gte":
        return {
          [row.fieldName]: helper({ gte: value }, { multiTableSearch: row.multiTableSearch })
        };
      case "lt":
        return {
          [row.fieldName]: helper({ lt: value }, { multiTableSearch: row.multiTableSearch })
        };
      case "lte":
        return {
          [row.fieldName]: helper({ lte: value }, { multiTableSearch: row.multiTableSearch })
        };
      case "equals":
        return {
          [row.fieldName]: helper(
            { equals: value },
            {
              multiTableSearch: row.multiTableSearch
            }
          )
        };
      case "notEquals":
        return {
          [row.fieldName]: helper(
            { not: value },
            {
              multiTableSearch: row.multiTableSearch
            }
          )
        };
      default:
        return {};
    }
  }
}
